import { Routes } from '@angular/router';
import { AttachmentProjectComponent } from '../../../pages/project/project-details/project-attachment/attachment-project.component';
import { ProjectDetailComponent } from '../../../pages/project/project-details/project-detail.component';
import { EditProjectComponent } from '../../../pages/project/project-details/project-edit/edit-project.component';
import { ManageProjectComponent } from '../../../pages/project/project-details/project-edit/manage-project/manage-project.component';
import { ProjectExpensesComponent } from '../../../pages/project/project-details/project-expenses/project-expenses.component';
import { ProjectProgressComponent } from '../../../pages/project/project-details/project-progress/project-progress.component';
import { ProjectListComponent } from '../../../pages/project/project-list/project-list.component';
import { UrlSegmentDelimiter } from '../../constants-repository/app-style.constants';
import { PendingChangesGuard } from '../../guards/pending-changes.guard';
import { projectDataResolver } from '../../resolver/project/project-data.resolver';
import { ProjectStatusResolver } from '../../resolver/project/project-status.resolver';
import { ShiveRoutes } from '../segments/route-segments';

export const ProjectRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: ShiveRoutes.ProjectOverview,
  },
  {
    path: ShiveRoutes.Overview,
    component: ProjectListComponent,
  },
  {
    path: ShiveRoutes.Create,
    component: ManageProjectComponent,
    canDeactivate: [PendingChangesGuard],
    resolve: {
      projectStatuses: ProjectStatusResolver,
    },
  },
  {
    path: ShiveRoutes.Detail,
    component: ProjectDetailComponent,
    resolve: {
      data: projectDataResolver,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: ShiveRoutes.Progress,
      },
      {
        path: `${ShiveRoutes.Progress + UrlSegmentDelimiter}:id`,
        component: ProjectProgressComponent,
      },
      {
        path: `${ShiveRoutes.Edit + UrlSegmentDelimiter}:id`,
        component: EditProjectComponent,
        canDeactivate: [PendingChangesGuard],
        resolve: {
          projectStatuses: ProjectStatusResolver,
        },
      },
      {
        path: `${ShiveRoutes.Expenses + UrlSegmentDelimiter}:id`,
        component: ProjectExpensesComponent,
      },
      {
        path: `${ShiveRoutes.Attachments + UrlSegmentDelimiter}:id`,
        component: AttachmentProjectComponent,
      },
    ],
  },
];
